import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import AuthLayout from '~/pages/_layouts/auth';
import DefaultLayout from '~/pages/_layouts/default';

import { store } from '~/store';

export default function RouterWrapper({
  component: Component,
  isPrivate = false,
  // acesso = null,
  isDashboard = false,
  ...rest
}) {
  const { signed } = store.getState().auth;
  const { acessos } = store.getState().permissoes;

  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }

  if (signed && !isPrivate) {
    return <Redirect to="/dashboard" />;
  }

  if (signed && isPrivate && !isDashboard && !acessos) {
    return <Redirect to="/dashboard" />;
  }

  // if (acesso && acessos && (!acessos[acesso] || !acessos[acesso].exibir)) {
  //   return <Redirect to="/dashboard" />;
  // }

  const Layout = signed ? DefaultLayout : AuthLayout;

  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouterWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  isDashboard: PropTypes.bool,
  acesso: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouterWrapper.defaultProps = {
  isPrivate: false,
  isDashboard: false,
  acesso: null,
};
